import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import BreadCrumb from "../../Global/BreadCrumb";
import AddBotanicalFamilyForm from "../../BotanicalFamily/AddBotanicalFamily/AddBotanicalFamilyForm";

const AddGrowthStage = () => {
  const { t } = useTranslation();
  const { fetchData, response } = useAxios(
    process.env.REACT_APP_API_URL + "/api/admin/growth_stages/new/",
    "POST",
    false,
    "",
    true,
    true
  );
  return (
    <div className="parent-container">
      <h1 className="font-semibold text-default-text text-[16px] mt-5">
        {t("Growth stages.Add growth stage")}
      </h1>
      <BreadCrumb
        breadcrumb={[
          { name: t("Navbar.Settings"), url: "" },
          {
            name: t("Growth stages.Growth stages"),
            url: "/setting/growth-stages",
          },
          { name: t("Growth stages.Add growth stage"), url: "" },
        ]}
      />
      <div className="flex flex-wrap justify-between mt-4">
        <div className=" w-full h-fit lg:w-[49%] sc:w-[611px] bg-white rounded-md p-7 relative">
          <AddBotanicalFamilyForm
            link="/setting/growth-stages"
            title={t("Growth stages.Growth stage")}
            send={fetchData}
            sendResponse={response}
            textButton={t("Growth stages.Add growth stage")}
          />
        </div>
        <div className="w-full h-fit lg:w-[48%] sc:w-[559px] bg-white rounded-md p-8 mt-4 lg:mt-0">
          <img
            src="/img/Add growth stage.svg"
            alt="Add growth stage"
            className="mt-4 ml-2"
          />
        </div>
      </div>
    </div>
  );
};

export default AddGrowthStage;
